import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsCustom4Route: InvariantJiraRoute = {
	name: 'servicedesk-reports-custom',
	path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId',
};
